import { f as filterDistinct } from './filterDistinct-c0340793.js';
import { g as getAccessTokens, s as setAccessTokens } from './accessTokens-74425a4a.js';

var downloadFile = function (fetchFn, url, name) {
    if (fetchFn === void 0) { fetchFn = fetch; }
    return fetchFn(url)
        .then(function (response) {
        if (response.status !== 200) {
            throw new Error("Could not download file (" + response.status + ").");
        }
        return response;
    })
        .then(function (response) { return response.blob(); })
        .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.setAttribute('href', objectUrl);
        anchor.download = name;
        anchor.target = '_self';
        anchor.click();
        setTimeout(function () {
            // Not sure why this works (it probably prevents some race condition in iOS Safari).
            // If removed download file will crash on iOS Safari
            URL.revokeObjectURL(objectUrl);
        }, 1000);
        return null;
    });
};

var fetchGraphQL = function (fetchFn, url, text, variables) {
    if (fetchFn === void 0) { fetchFn = fetch; }
    var body = {
        query: text,
        variables: variables,
    };
    return fetchFn(url, {
        body: JSON.stringify(body),
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
    })
        .then(function (response) { return response.json(); })
        .then(function (json) {
        var _a, _b;
        if (json && (json === null || json === void 0 ? void 0 : json.errors)) {
            if (['AUTH_TOKEN_EXPIRED', 'AUTH_INVALID_TOKEN'].includes((_a = json.errors[0].extensions) === null || _a === void 0 ? void 0 : _a.code)) {
                throw new Error('ACCESS_TOKEN_EXPIRED');
            }
            else {
                throw new Error(filterDistinct((_b = json === null || json === void 0 ? void 0 : json.errors) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item === null || item === void 0 ? void 0 : item.message; })).join('. '));
            }
        }
        return json;
    });
};

var TOKEN_REFRESH_EVENT = 'TOKEN_REFRESH';
var refreshPromise;
var refreshAccessToken = function (url) {
    if (refreshPromise) {
        console.log('Access token refresh already in progress');
        return refreshPromise;
    }
    refreshPromise = new Promise(function (resolve, reject) {
        var _a = getAccessTokens(), token = _a.accessToken, refreshToken = _a.refreshToken;
        var body = JSON.stringify({
            token: token,
            refreshToken: refreshToken,
        });
        return fetch(url, {
            body: body,
            cache: 'no-cache',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
            mode: 'cors',
        })
            .then(function (response) {
            if (response.status !== 200) {
                reject(response.statusText);
                return;
            }
            return response;
        })
            .then(function (response) { return response.json(); })
            .then(function (json) {
            var token = json.token, refreshToken = json.refreshToken;
            setAccessTokens(token, refreshToken);
            window.dispatchEvent(new CustomEvent(TOKEN_REFRESH_EVENT, {
                detail: {
                    token: token,
                    refreshToken: refreshToken,
                },
            }));
            refreshPromise = null;
            resolve(json);
            return {
                accessToken: token,
                refreshToken: refreshToken,
            };
        });
    });
    return refreshPromise;
};

var uploadFile = function (fetchFn, url, file) {
    if (fetchFn === void 0) { fetchFn = fetch; }
    var body = new FormData();
    body.append('file', file);
    return fetchFn(url, {
        body: body,
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
    }).then(function (response) { return response.json(); });
};

export { TOKEN_REFRESH_EVENT as T, downloadFile as d, fetchGraphQL as f, refreshAccessToken as r, uploadFile as u };
//# sourceMappingURL=uploadFile-6fa21335.js.map
